// extracted by mini-css-extract-plugin
export default {"sticky":"Cashup_sticky__KWm3Z"};